module.exports = __webpack_public_path__ + "img/hu.a1bca37f.svg";